<div class="container">
  <div class="container_content">
    <div class="header">
      <div class="header__user">
        <img class="avatar" [src]="user?.profilePictureUrl" />
        <div class="header__user__text">
          <div class="header__user__text__name">{{ user?.name }}</div>
          <div class="header__user__text__email">{{ user?.email }}</div>
        </div>
      </div>
      <pdq-button
        iconColor="var(--on-surface-light)"
        [disabled]="saveIsLoading"
        (onClick)="drawer.close()"
        variant="ghost"
        icon="close"></pdq-button>
    </div>
    <div class="content">
      <div class="content__header">
        <p>Profile information</p>
        @if (!isEdit) {
          <pdq-button
            pdqPopover
            variant="ghost"
            icon="dots_menu"
            [forcePosition]="'bottom_right'"
            [popoverTemplate]="popoverTemplate"
            [popoverContent]="popoverContent"></pdq-button>
        }
        <ng-template #popoverTemplate>
          <pdq-popover-container [loading]="false">
            <div class="action-list" #popoverContent>
              @for (action of userActions; track action) {
                <pdq-option
                  (onSelect)="handleAction($event)"
                  [optionId]="action.id"
                  [variant]="action.destructive ? 'danger' : 'ghost'"
                  >{{ action.label }}</pdq-option
                >
              }
            </div></pdq-popover-container
          >
        </ng-template>
      </div>
      @if (responseErrors?.length) {
        <pdq-banner
          [content]="responseErrors"
          bannerTitle="To update this user, next changes need to be made:"
          variant="danger"></pdq-banner>
      }
      <div class="details">
        @if (!isEdit) {
          <div class="details__detail" [ngClass]="{ isEdit: isEdit }">
            <div class="details__detail__key">Name:</div>
            <div class="details__detail__value">{{ user?.name || '' }}</div>
          </div>
        } @else {
          <pdq-input
            [value]="userForm.value.name"
            [control]="userForm.controls.name"
            [dirty]="userForm.controls.name.dirty"
            [disabled]="userForm.controls.name.disabled"
            variant="form"
            label="Name"></pdq-input>
        }
        @if (!isEdit) {
          <div class="details__detail" [ngClass]="{ isEdit: isEdit }">
            <div class="details__detail__key">Title:</div>
            <div class="details__detail__value">{{ user?.metadata?.title || '' }}</div>
          </div>
        } @else {
          <pdq-input
            [value]="userForm.value.title"
            [control]="userForm.controls.title"
            [dirty]="userForm.controls.title.dirty"
            [disabled]="userForm.controls.title.disabled"
            variant="form"
            label="Title"></pdq-input>
        }
        @if (!isEdit) {
          <div class="details__detail" [ngClass]="{ isEdit: isEdit }">
            <div class="details__detail__key">Phone number:</div>
            <div class="details__detail__value">{{ user?.phoneNumber || '' }}</div>
          </div>
        } @else {
          <pdq-input
            [value]="userForm.value.phone"
            [control]="userForm.controls.phone"
            [dirty]="userForm.controls.phone.phone"
            [disabled]="userForm.controls.phone.disabled"
            variant="form"
            label="Phone number"></pdq-input>
        }
        @if (shopSupportsLocations) {
          <div>
            @if (!isEdit) {
              <div class="details__detail">
                <div class="details__detail__key">Warehouses:</div>
                <div class="details__detail__value">
                  {{ (userLocations || shopLocations | locationsViewPipe) || '' }}
                </div>
              </div>
            } @else {
              <pdq-dropdown
                selectBy="checked"
                multiSelect="true"
                title="Warehouses"
                [defaultOption]="shopLocations | LocationOptionsPipe: userLocations || shopLocations"
                (onMultiSelectOptionChecked)="locationsSelectHandler($event)"
                placeholder="Select locations"
                [options]="shopLocations | LocationOptionsPipe: userLocations || shopLocations"></pdq-dropdown>
            }
          </div>
        }
        <div class="details__detail">
          <div class="details__detail__key">Email:</div>
          <div class="details__detail__value link">
            @if (user?.email) {
              <pdq-link [label]="user.email" [url]="'mailto:' + user.email"></pdq-link>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container__actions">
    @if (isEdit) {
      <footer>
        <pdq-button [disabled]="saveIsLoading" label="Discard" (onClick)="handleDiscard()"></pdq-button>
        <pdq-button
          [disabled]="userForm?.dirty !== true"
          variant="primary"
          [loading]="saveIsLoading"
          label="Save"
          (onClick)="handleSave()"></pdq-button>
      </footer>
    }
  </div>
</div>
